import apiService from "../common/commonApi";

export const projectType = {};

projectType.list = async (param) => {    
    return apiService.Get('projecttype-list', param);
}

projectType.add = async (param) => {    
    return apiService.Post('projecttype-create', param);
}

projectType.delete = async (param) => {    
    return apiService.Post('projecttype-delete', param);
}

projectType.update = async (param) => {    
    return apiService.Post('projecttype-update', param);
}